var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFollowupFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 80,
    viewBox: "0 0 78 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5383 77.3833C35.9232 80.8084 42.0768 80.8084 46.4617 77.3833L68.5999 60.0907C71.0764 58.1562 72.7048 55.3357 73.1418 52.2239L77.0486 24.4052C77.8224 18.8953 74.7456 13.5661 69.5869 11.4812L43.5419 0.955246C40.6284 -0.222221 37.3715 -0.222214 34.4581 0.955246L8.41306 11.4812C3.25438 13.5661 0.177568 18.8953 0.95137 24.4052L4.85812 52.2239C5.29514 55.3357 6.92357 58.1563 9.40002 60.0907L31.5383 77.3833Z",
    fill: "#4AB7F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2741 68.1497C36.639 70.7756 41.3613 70.7756 44.7262 68.1497L61.7151 54.892C63.6155 53.409 64.8652 51.2465 65.2005 48.8608L68.1986 27.5332C68.7924 23.3089 66.4312 19.2231 62.4725 17.6248L42.4856 9.55485C40.2498 8.65213 37.7505 8.65213 35.5147 9.55485L15.5278 17.6248C11.5691 19.2231 9.20793 23.3089 9.80174 27.5332L12.7998 48.8608C13.1351 51.2465 14.3848 53.409 16.2852 54.892L33.2741 68.1497Z",
    fill: "#6DC5F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2194 22.1914H51.781C53.5383 22.1914 54.9762 23.6292 54.9762 25.3866V50.9482C54.9762 52.7056 53.5383 54.1434 51.781 54.1434H26.2194C24.462 54.1434 23.0242 52.7056 23.0242 50.9482V25.3866C23.0242 23.6292 24.462 22.1914 26.2194 22.1914ZM26.22 50.9479H32.6104V44.5575H26.22V50.9479ZM32.6104 41.3627H26.22V34.9723H32.6104V41.3627ZM26.22 31.7768H32.6104V25.3864H26.22V31.7768ZM42.195 50.9479H35.8046V44.5575H42.195V50.9479ZM35.8046 41.3627H42.195V34.9723H35.8046V41.3627ZM42.195 31.7768H35.8046V25.3864H42.195V31.7768ZM45.3904 50.9479H51.7808V44.5575H45.3904V50.9479ZM51.7808 41.3627H45.3904V34.9723H51.7808V41.3627ZM45.3904 31.7768H51.7808V25.3864H45.3904V31.7768Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowupFilled);
export default __webpack_public_path__ + "static/media/followup-filled.c8552a8a.svg";
export { ForwardRef as ReactComponent };